import * as THREE from 'three';
//
import * as mutationTypes from '../mutation-types';

const state = () => ({
  snapshots: [],
  selectedSnapshot: null,
});

const getters = {
  snapshots: state => state.snapshots,
  selectedSnapshot: state => state.selectedSnapshot,
  createMeshesMap: () => (meshes) => {

    return meshes.map(mesh => {

      let uniforms = mesh.material.userData.uniforms;
      let meshUniforms;

      if(uniforms){
        meshUniforms = {
          repeatX: { value: uniforms.repeatX.value },
          repeatY: { value: uniforms.repeatY.value },
          tScale: { value: uniforms.tScale.value },
          tRotation: { value: uniforms.tRotation.value },
          tOffsetX: { value: uniforms.tOffsetX.value },
          tOffsetY: { value: uniforms.tOffsetY.value },
          // tSelfMap: { ...uniforms.tSelfMap },
          // alphaIntensity: { ...uniforms.alphaIntensity },
        }
      } else {
        meshUniforms = {};
      }

      return {
        name: mesh.name,
        uniforms: meshUniforms,
        fabric: {
          id: mesh.userData.fabric?.id,
          name: mesh.userData.fabric?.name,
        },
        color: mesh.material.color ? mesh.material.color.getHexString() : 'ffffff',
        texture: mesh.material.userData.texture ? {
          img_id: mesh.material.userData.texture.img_id
        } : null,
      }

    });

  }
};

const mutations = {
  //  todo CREATE_SNAPSHOT
  //  todo DELETE_SNAPSHOT
  [mutationTypes.SET_SNAPSHOT] (state,snapshot) {
    state.selectedSnapshot = snapshot;
  },
  [mutationTypes.ADD_SNAPSHOT] (state,snapshot) {
    state.snapshots.unshift(snapshot);
  },
  [mutationTypes.SET_SNAPSHOTS] (state,snapshots) {
    state.snapshots = JSON.parse(JSON.stringify(snapshots));
  },
  [mutationTypes.REMOVE_SNAPSHOT] (state,snapshot) {

    
    let i = state.snapshots.indexOf(snapshot);
    // console.log(i);

    if(i >= 0) {
      state.snapshots.splice(i,1);
    }

    if(state.selectedSnapshot === snapshot) {
      state.selectedSnapshot = null;
    }

  }
};

const actions = {
  createSnapshot: ({ commit, dispatch, rootGetters, getters },payload) => {
    //salvo i riferimenti per il manichino
    let mannequin = {
      type: rootGetters['mannequin/mannequin'].type,
      color: rootGetters['mannequin/mannequin'].color,
    };

    //salvo i riferimenti per la rotazione del poser
    let poser = {
      rotation: {
        x: rootGetters['mannequin/poser'].inst.rotation.x,
        y: rootGetters['mannequin/poser'].inst.rotation.y,
        z: rootGetters['mannequin/poser'].inst.rotation.z,
      },
    }

    //salvo i modelli indossati con le relative informazioni su materiali e texture
    let selectedClothes = [];

    rootGetters['clothes/selectedClothes'].forEach(el => {

      let dress = {
        id: el.id,
        meshes: []
      };
      let meshes = rootGetters['clothes/meshesOfDress'](el);
      let accessories = rootGetters['clothes/accessoriesOfDress'](el);

      dress.meshes = getters['createMeshesMap'](meshes);
      dress.accessories = getters['createMeshesMap'](accessories);

      selectedClothes.push(dress);
    });

    const selectedShoes = rootGetters['shoes/selectedShoes'];
    //salvo il riferimento alle scarpe e le info di colore delle mesh
    let shoes = {
      id: selectedShoes && selectedShoes.id,
      meshes: []
    }

    if(selectedShoes && selectedShoes.inst) {
      let shoesMeshes = rootGetters['objects3d/accessoriesOf'](selectedShoes.inst);

      shoes.meshes = getters['createMeshesMap'](shoesMeshes);

    }
    

    //salvo il colore di background della scena
    let scene = {
      backgroundColor: rootGetters['scene'].backgroundColor,
    }

    //salvo la posizione e lo zoom della camera
    let camera = {
      position: {
        x: rootGetters['camera/camera'].inst.position.x,
        y: rootGetters['camera/camera'].inst.position.y,
        z: rootGetters['camera/camera'].inst.position.z,
      },
      fov: rootGetters['camera/camera'].inst.fov,
    }

    let snapshot = {
      ...payload, //image, data, title
      scene,
      camera,
      poser,
      mannequin,
      id : '_' + Math.random().toString(36).substr(2, 9),
      selectedClothes,
      shoes,
    };

    // console.log(snapshot);

    commit(mutationTypes.ADD_SNAPSHOT,JSON.parse(JSON.stringify(snapshot)));
    dispatch('setSnapshot',snapshot);
    // console.log(snapshot);
  },
  //  todo deleteSnapshot
  loadSnapshot: ({ dispatch, rootGetters, commit },payload) => {
    // console.log(payload);
    commit('clothes/'+mutationTypes.SET_SELECTED_DRESS,null,{root:true});
    return new Promise((resolve,reject) => {

      try {

        let snapshot = JSON.parse(JSON.stringify(payload));

        dispatch('setSnapshot',snapshot);

        let m = rootGetters['mannequin/mannequinByType'](snapshot.mannequin.type);

        if(m) {
          dispatch('mannequin/setMannequin',{
            payload: m,
            loadDefaultClothes: false,
            force: true,
          },{root:true})
          .then(() => {
            // carico le impostazioni delle scarpe
            
            // console.log(snapshot.shoes);

            let shoes =  snapshot.shoes ? rootGetters['shoes/shoesById'](snapshot.shoes.id) : null;

            return dispatch('shoes/setSelectedShoes',shoes,{root: true});

          }).then(() => {

            return dispatch('setShoesConfig',snapshot);

          }).then(() => {



            // todo refactoring naming: el, mesh, mes, ... casotto!!!
            // todo risolvere problema: non aggiorna i controlli nell'interfaccia quando carico snapshot
            snapshot.selectedClothes.forEach(async (el) => {

              // console.log(el);
              await dispatch('clothes/wearDress',rootGetters['clothes/dressById'](el.id),{root:true});

              

              // set accessories configuration
              if(el.accessories && el.accessories.length) {
                let accessories = rootGetters['clothes/accessoriesOfDress'](rootGetters['clothes/dressById'](el.id));

                accessories.forEach( async (acc,i) => {

                  dispatch('clothes/setSelectedMesh',acc,{root:true});
                  await dispatch('clothes/setMeshColor','#'+el.accessories[i].color,{root:true});

                });
              }
              
              // set meshes configuration
              let meshes = rootGetters['clothes/meshesOfDress'](rootGetters['clothes/dressById'](el.id));
              meshes.forEach(async (mesh,i) => {

                //todo capire se ce un modo migliore per trovare la corrispondenza: problema, se cambio nome al modello non trova piu la corrispondenza
                let mes = el.meshes.filter(me => me.name === mesh.name)[0];

                if(!mes) {
                  mes  = el.meshes[i]; //nel caso in cui non trovo la corrispondenza con il nome prendo l'elemento corrispondente allo stesso indice
                }

                if(mes) {

                  let fabric = rootGetters['fabrics/fabricById'](mes.fabric.id);

                  await dispatch('fabrics/applyFabric',{payload: fabric, mesh: mesh},{root:true});

                  // console.log(mes);
                  dispatch('clothes/setSelectedMesh',mesh,{root:true});
                  await dispatch('clothes/setMeshColor','#'+mes.color,{root:true});

                  // se la mesh ha una texture e il colore è bianco allora applico la texture
                  if(mes.texture  && mes.color == 'ffffff') {
                    // console.log('texture!!')
                    await dispatch('textures/setSelectedTexture',rootGetters['textures/textureById'](mes.texture.img_id),{root:true});

                    // console.log(mes.uniforms);
                    let uniforms = JSON.parse(JSON.stringify(mes.uniforms));

                    dispatch('fabrics/setUniforms',{to: mesh.material.userData.uniforms, from: uniforms},{root:true});

                    // mesh.material.userData.uniforms.repeatX.value = uniforms.repeatX.value
                    // mesh.material.userData.uniforms.repeatY.value = uniforms.repeatY.value
                    // mesh.material.userData.uniforms.tScale.value = uniforms.tScale.value
                    // mesh.material.userData.uniforms.tRotation.value = uniforms.tRotation.value
                    // mesh.material.userData.uniforms.tOffsetX.value = uniforms.tOffsetX.value
                    // mesh.material.userData.uniforms.tOffsetY.value = uniforms.tOffsetY.value
                    // mesh.material.needsUpdate = true;

                  } else if(mes.texture) { //altrimenti se ho la texture ma il colore impostato non è bianco cancello la texture salvata
                    //fix bug color and texture conflict
                    // console.log('clear texture!!')
                    mes.texture = null;
                  }

                  // console.log('after apply fabric',mesh);
                  // console.log('render');
                  dispatch('render',null,{root:true});
                }

              })

            });


            let scene = rootGetters['scene'];
            scene.backgroundColor = snapshot.scene.backgroundColor;

            //todo smooth change
            let poser = rootGetters['mannequin/poser'].inst;
            // console.log(poser);
            poser.rotation.y = snapshot.poser.rotation.y;
            poser.needsUpdate = true;

            //todo smooth change
            let camera = rootGetters['camera/camera'].inst;
            camera.fov = snapshot.camera.fov;

            camera.position = new THREE.Vector3(snapshot.camera.position.x,snapshot.camera.position.y,snapshot.camera.position.z);
            camera.updateProjectionMatrix();

            //todo questo viene chiamato prima di eseguire tutto il caricamento dello snapshot -> problema con le promise
            // console.log('render');
            dispatch('render',null,{root:true});

            resolve();
          });
        } else {
          // console.log('Nessun manichino di questo tipo trovato.');
          resolve();
        }

      } catch (e) {
        reject(`An error occurred: ${e}.`);
      }

    })




    //todo check scene change
    //todo

  },
  setShoesConfig: ({dispatch,rootGetters},payload) => {
    return new Promise((resolve,reject) => {
      try {

        const selectedShoes = rootGetters['shoes/selectedShoes'];

        if(!selectedShoes || !payload.shoes) {
          resolve();
          return
        }

        let { meshes } = payload.shoes;
        let selectedShoesMeshes = rootGetters['objects3d/accessoriesOf'](selectedShoes.inst);

        for(let i = 0; i < meshes.length;i++) {

          let snapMesh = meshes[i];
          dispatch('clothes/setSelectedMesh',selectedShoesMeshes[i],{root:true});
          dispatch('clothes/setMeshColor','#'+snapMesh.color,{root:true});

        }           

        resolve();

      } catch (error) {
        reject(error);
      }
    });
  },
  setSnapshot: ({ commit },payload) => {
    commit(mutationTypes.SET_SNAPSHOT,payload);
  },
  setSnapshots: ({ commit, dispatch },payload) => { //setta gli snapshots salvati, carica il primo snapshot
    return new Promise((resolve,reject) => {

      try {

        commit(mutationTypes.SET_SNAPSHOTS,payload);
        dispatch('loadSnapshot',payload[0]).then(() => {
          resolve();
        })

      } catch (e) {
        reject(`An error occurred: ${e}.`);
      }

    })


  },
  deleteSnapshot: ({ state, commit }, payload) => {
    // console.log('deleteSnapshot');

    let el = state.snapshots.filter(el => el.id === payload.id)[0];
    // console.log(el);
    if(el) {
      commit(mutationTypes.REMOVE_SNAPSHOT, el);
    }
    // console.log('selected',el);
    if(el.id === payload.id) {
      commit(mutationTypes.SET_SNAPSHOT,null);
    }

  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}